import { isIE } from '../utilities/is-ms';

if (isIE()) {
  $('.js-image-fit').each((index, element) => {
    const $this = $(element);
    const $image = $this.find('img');
    const imageSource = $image.attr('src') || $image.data('src');

    $this.css('background-image', `url('${imageSource}')`);
    $image.addClass('sr-only');
  });
}
